import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactSlider from "react-slider";
import { Button } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

/**
 * Controlled filter UI. Parent (ParcelScreen) supplies controlled values + setters.
 * Supports: price, area, appreciation, flood, zone, zestimate, spread.
 */
export default function ParcelFilters({
  parcelData = [],
  priceRange,
  setPriceRange,
  areaRange,
  setAreaRange,
  zestimateRange,
  setZestimateRange,
  spreadRange,
  setSpreadRange,
  appreciationValue,
  setAppreciationValue,
  floodRiskFilter,
  setFloodRiskFilter,
  zoneCodeFilter,
  setZoneCodeFilter,
  sliderMinMax = {},
  zoneCodes = [],
  floodOptions = [],
  onChange = () => { },
  listedSalesFilter = "All",
  setListedSalesFilter = () => { },
  listedOptions = ["All", "ActiveListing", "PendingSale", "Unlisted"],
}) {
  const containerRef = useRef(null);
  // const [open, setOpen] = useState({ price: false, area: false, app: false, flood: false, zone: false, zestimate: false, spread: false });

  // useEffect(() => {
  //   const onDoc = (e) => {
  //     if (!containerRef.current) return;
  //     if (!containerRef.current.contains(e.target)) setOpen({ price: false, area: false, app: false, flood: false, zone: false, zestimate: false, spread: false });
  //   };
  //   document.addEventListener("click", onDoc);
  //   return () => document.removeEventListener("click", onDoc);
  // }, []);

  // // immediate apply: whenever controlled values change, notify parent (onChange is optional)
  // useEffect(() => {
  //   if (typeof onChange === "function") onChange(parcelData || []);
  // }, [parcelData, priceRange, areaRange, zestimateRange, spreadRange, appreciationValue, floodRiskFilter, zoneCodeFilter, onChange]);

  const [open, setOpen] = useState({ price: false, area: false, app: false, flood: false, zone: false, zestimate: false, spread: false, listed: false });

  const isPriceActive =
    Array.isArray(priceRange) &&
    (priceRange[0] > (sliderMinMax?.minPrice ?? 0) || priceRange[1] < (sliderMinMax?.maxPrice ?? 1000000));
  const isAreaActive =
    Array.isArray(areaRange) &&
    (areaRange[0] > (sliderMinMax?.minArea ?? 0) || areaRange[1] < (sliderMinMax?.maxArea ?? 5000));
  const isZestimateActive =
    Array.isArray(zestimateRange) &&
    (zestimateRange[0] > (sliderMinMax?.minZestimate ?? 0) || zestimateRange[1] < (sliderMinMax?.maxZestimate ?? 1000000));
  const isSpreadActive =
    Array.isArray(spreadRange) &&
    (spreadRange[0] > (sliderMinMax?.minSpread ?? 0) || spreadRange[1] < (sliderMinMax?.maxSpread ?? 100));
  const isAppActive = appreciationValue !== "All";
  const isFloodActive = floodRiskFilter !== "All";
  const isZoneActive = zoneCodeFilter !== "All";
  const isListedActive = listedSalesFilter !== "All";

  const activeBg = "#1c8f7d";
  const inactiveBg = "transparent";
  const activeColor = "#fff";
  const inactiveColor = "#333";


  // thumb/track renderers to style slider green endpoints/active track
  const renderThumb = (thumbProps, state) => {
    return (
      <div
        {...thumbProps}
        style={{
          ...thumbProps.style,
          height: 16,
          width: 16,
          top: -3,
          borderRadius: 8,
          background: "#1c8f7d",
          boxShadow: "0 0 0 3px rgba(28,143,125,0.12)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 3,
        }}
      />
    );
  };

  const renderTrack = (trackProps, state) => {
    // state.index === 1 is the active (between thumbs) track in react-slider
    const background = state.index === 1 ? "#1c8f7d" : "#e6e6e6";
    return <div {...trackProps} style={{ ...trackProps.style, height: 8, background, borderRadius: 6, zIndex: state.index === 1 ? 2 : 1 }} />;
  };

  // small inline CSS fix to ensure slider container doesn't hide the thumb
  useEffect(() => {
    const id = "parcel-filter-slider-css";
    if (!document.getElementById(id)) {
      const style = document.createElement("style");
      style.id = id;
      style.innerHTML = `
        .react-slider { height: 24px; }
        .react-slider .thumb { box-shadow: none; }
      `;
      document.head.appendChild(style);
    }
  }, []);

  useEffect(() => {
    const onDoc = (e) => {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target)) setOpen({ price: false, area: false, app: false, flood: false, zone: false, zestimate: false, spread: false, listed: false });
    };
    document.addEventListener("click", onDoc);
    return () => document.removeEventListener("click", onDoc);
  }, []);
  const formatCurrency = (n) => (isNaN(n) ? "N/A" : "$" + Math.round(n).toLocaleString());

  return (
    <div class="filterOuter" ref={containerRef} style={{ display: "flex", gap: 12, alignItems: "center", backgroundColor: "#edf6f5" }}>
      {/* Land Value */}
      <div>
        {/* <Button color="primary filter-button" variant="text" endIcon={<ArrowDropDownIcon />} onClick={() => setOpen((s) => ({ ...s, price: !s.price }))} sx={{ textTransform: "none", color: open.price ? "#fff" : "#333", backgroundColor: open.price ? "#1c8f7d" : "transparent", borderRadius: "6px" }}> */}

        <Button
          color="primary filter-button"
          variant="text"
          endIcon={<ArrowDropDownIcon />}
          // onClick={() => setOpen((s) => ({ ...s, price: !s.price }))}
          onClick={() => setOpen({ price: true, area: false, app: false, flood: false, zone: false, zestimate: false, spread: false, listed: false })}
          sx={{
            textTransform: "none",
            color: open.price ? activeColor : (isPriceActive ? activeColor : inactiveColor),
            backgroundColor: open.price ? activeBg : (isPriceActive ? activeBg : inactiveBg),
            borderRadius: "6px",
          }}
        >
          Land Value
        </Button>
        {open.price && (
          <div
            className="price-filter-container"
            style={{
              position: "absolute",
              left: 30,
              top: 163,
            }}
          // style={{ position: "absolute", top: 153, left: 30, zIndex: 999, background: "#fff", padding: 12, borderRadius: 6, boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}
          >
            <div style={{ width: 320 }}>
              <ReactSlider value={priceRange} renderThumb={renderThumb}
                renderTrack={renderTrack}
                className="react-slider"
                thumbClassName="thumb" onChange={setPriceRange} min={sliderMinMax.minPrice ?? 0} max={sliderMinMax.maxPrice ?? 1000000} step={Math.max(1, Math.round(((sliderMinMax.maxPrice ?? 1000000) - (sliderMinMax.minPrice ?? 0)) / 100))} />
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
                <span>{formatCurrency(priceRange[0])}</span>
                <span>{formatCurrency(priceRange[1])}</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Zestimate */}

      <div>
        {/* <Button  color="primary filter-button" variant="text" endIcon={<ArrowDropDownIcon />} onClick={() => setOpen((s) => ({ ...s, zestimate: !s.zestimate }))} sx={{ textTransform: "none", color: open.zestimate ? "#fff" : "#333", backgroundColor: open.zestimate ? "#1c8f7d" : "transparent", borderRadius: "6px" }}> */}
        <Button
          color="primary filter-button"
          variant="text"
          endIcon={<ArrowDropDownIcon />}
          // onClick={() => setOpen((s) => ({ ...s, zestimate: !s.zestimate }))}
          onClick={() => setOpen({ price: false, area: false, app: false, flood: false, zone: false, zestimate: true, spread: false, listed: false })}
          sx={{
            textTransform: "none",
            color: open.zestimate ? activeColor : (isZestimateActive ? activeColor : inactiveColor),
            backgroundColor: open.zestimate ? activeBg : (isZestimateActive ? activeBg : inactiveBg),
            borderRadius: "6px",
          }}

        >

          {/* Zestimate */}
          Price
        </Button>
        {open.zestimate && (
          <div
            className="price-filter-container"
            style={{

              left: 570,
              top: 163,

            }}>
            {/* style={{ position: "absolute", top: 130, left: 740, zIndex: 999, background: "#fff", padding: 12, borderRadius: 6, boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}> */}
            <div style={{ width: 320 }}>
              <ReactSlider value={zestimateRange} renderThumb={renderThumb}
                renderTrack={renderTrack}
                className="react-slider"
                thumbClassName="thumb" onChange={setZestimateRange} min={sliderMinMax.minZestimate ?? 0} max={sliderMinMax.maxZestimate ?? 1000000} step={Math.max(1, Math.round(((sliderMinMax.maxZestimate ?? 1000000) - (sliderMinMax.minZestimate ?? 0)) / 100))} />
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
                <span>{formatCurrency(zestimateRange[0])}</span>
                <span>{formatCurrency(zestimateRange[1])}</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Spread */}
      <div>
        {/* <Button  color="primary filter-button" variant="text" endIcon={<ArrowDropDownIcon />} onClick={() => setOpen((s) => ({ ...s, spread: !s.spread }))} sx={{ textTransform: "none", color: open.spread ? "#fff" : "#333", backgroundColor: open.spread ? "#1c8f7d" : "transparent", borderRadius: "6px" }}> */}
        <Button
          color="primary filter-button"
          variant="text"
          endIcon={<ArrowDropDownIcon />}
          // onClick={() => setOpen((s) => ({ ...s, spread: !s.spread }))}
          onClick={() => setOpen({ price: false, area: false, app: false, flood: false, zone: false, zestimate: false, spread: true, listed: false })}
          sx={{
            textTransform: "none",
            color: open.spread ? activeColor : (isSpreadActive ? activeColor : inactiveColor),
            backgroundColor: open.spread ? activeBg : (isSpreadActive ? activeBg : inactiveBg),
            borderRadius: "6px",
          }}
        >
          Spread %
        </Button>
        {open.spread && (
          <div

            className="price-filter-container"
            style={{

              left: 710,
              top: 163,

            }}>
            {/* style={{ position: "absolute", top: 130, left: 910, zIndex: 999, background: "#fff", padding: 12, borderRadius: 6, boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}> */}
            <div style={{ width: 300 }}>
              <ReactSlider value={spreadRange} renderThumb={renderThumb}
                renderTrack={renderTrack}
                className="react-slider"
                thumbClassName="thumb" onChange={setSpreadRange} min={sliderMinMax.minSpread ?? 0} max={sliderMinMax.maxSpread ?? 100} step={Math.max(1, Math.round(((sliderMinMax.maxSpread ?? 100) - (sliderMinMax.minSpread ?? 0)) / 100))} />
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
                <span>{Math.round(spreadRange[0])}%</span>
                <span>{Math.round(spreadRange[1])}%</span>
              </div>
            </div>
          </div>
        )}
      </div>


      {/* Area */}
      <div>
        {/* <Button color="primary filter-button" variant="text" endIcon={<ArrowDropDownIcon />} onClick={() => setOpen((s) => ({ ...s, area: !s.area }))} sx={{ textTransform: "none", color: open.area ? "#fff" : "#333", backgroundColor: open.area ? "#1c8f7d" : "transparent", borderRadius: "6px" }}> */}
        <Button
          color="primary filter-button"
          variant="text"
          endIcon={<ArrowDropDownIcon />}
          // onClick={() => setOpen((s) => ({ ...s, area: !s.area }))}
          onClick={() => setOpen({ price: false, area: true, app: false, flood: false, zone: false, zestimate: false, spread: false, listed: false })}
          sx={{
            textTransform: "none",
            color: open.area ? activeColor : (isAreaActive ? activeColor : inactiveColor),
            backgroundColor: open.area ? activeBg : (isAreaActive ? activeBg : inactiveBg),
            borderRadius: "6px",
          }}
        >
          {/* Area */}
          Parcel Size
        </Button>
        {open.area && (
          <div className="price-filter-container"
            style={{
              position: "absolute",
              left: 180,
              top: 163,
            }}
          // style={{ position: "absolute", top: 130, left: 160, zIndex: 999, background: "#fff", padding: 12, borderRadius: 6, boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}
          >

            <div style={{ width: 300 }}>
              <ReactSlider value={areaRange} renderThumb={renderThumb}
                renderTrack={renderTrack}
                className="react-slider"
                thumbClassName="thumb" onChange={setAreaRange} min={sliderMinMax.minArea ?? 0} max={sliderMinMax.maxArea ?? 5000} step={Math.max(1, Math.round(((sliderMinMax.maxArea ?? 5000) - (sliderMinMax.minArea ?? 0)) / 100))} />
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 3 }}>
                <span>{Math.round(areaRange[0]).toLocaleString()} ft²</span>
                <span>{Math.round(areaRange[1]).toLocaleString()} ft²</span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Appreciation */}

      {/* <div>
        <Button  color="primary filter-button" variant="text" endIcon={<ArrowDropDownIcon />} onClick={() => setOpen((s) => ({ ...s, app: !s.app }))} sx={{ textTransform: "none", color: open.app ? "#fff" : "#333", backgroundColor: open.app ? "#1c8f7d" : "transparent", borderRadius: "6px" }}>
          Appreciation
        </Button>
        {open.app && (
          <div style={{ position: "absolute", top: 130, left: 320, zIndex: 999, background: "#fff", padding: 6, borderRadius: 6, boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}>
            {["All", 1, 5, 10].map((v) => (
              <div key={v} onClick={() => { setAppreciationValue(v); setOpen((s) => ({ ...s, app: false })); }} style={{ padding: 8, cursor: "pointer", background: appreciationValue === v ? "#1c8f7d" : "transparent", color: appreciationValue === v ? "#fff" : "#000" }}>{v === "All" ? "All" : `${v}%+`}</div>
            ))}
          </div>
        )}
      </div> */}

      {/* Zone */}
      <div>
        {/* <Button   color="primary filter-button" variant="text" endIcon={<ArrowDropDownIcon />} onClick={() => setOpen((s) => ({ ...s, zone: !s.zone }))} sx={{ textTransform: "none", color: open.zone ? "#fff" : "#333", backgroundColor: open.zone ? "#1c8f7d" : "transparent", borderRadius: "6px" }}> */}
        <Button
          color="primary filter-button"
          variant="text"
          endIcon={<ArrowDropDownIcon />}
          // onClick={() => setOpen((s) => ({ ...s, zone: !s.zone }))}
          onClick={() => setOpen({ price: false, area: false, app: false, flood: false, zone: true, zestimate: false, spread: false, listed: false })}
          sx={{
            textTransform: "none",
            color: open.zone ? activeColor : (isZoneActive ? activeColor : inactiveColor),
            backgroundColor: open.zone ? activeBg : (isZoneActive ? activeBg : inactiveBg),
            borderRadius: "6px",
          }}
        >
          Zone Code
        </Button>
        {open.zone && (
          <div style={{ position: "absolute", top: 163, left: 300, zIndex: 999, background: "#fff", padding: 6, borderRadius: 6, boxShadow: "0 6px 20px rgba(0,0,0,0.12)", maxHeight: 300, overflow: "auto" }}>
            {zoneCodes.map((zc) => (
              <div key={zc} onClick={() => { setZoneCodeFilter(zc); setOpen((s) => ({ ...s, zone: false })); }} style={{ padding: 8, cursor: "pointer", background: zoneCodeFilter === zc ? "#1c8f7d" : "transparent", color: zoneCodeFilter === zc ? "#fff" : "#000" }}>{zc}</div>
            ))}
          </div>
        )}
      </div>


      {/* Flood */}

      {/* <div>

        <Button
          color="primary filter-button"
          variant="text"
          endIcon={<ArrowDropDownIcon />}

          onClick={() => setOpen({ price: false, area: false, app: false, flood: true, zone: false, zestimate: false, spread: false, listed: false })}
          sx={{
            textTransform: "none",
            color: open.flood ? activeColor : (isFloodActive ? activeColor : inactiveColor),
            backgroundColor: open.flood ? activeBg : (isFloodActive ? activeBg : inactiveBg),
            borderRadius: "6px",
          }}
        >
          Flood Risk
        </Button>
        {open.flood && (
          <div

            style={{
              position: "absolute",
              top: 163,
              left: 390,
              background: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
              borderRadius: "6px",
              zIndex: 999,
              padding: "6px 0",
              minWidth: "160px",
            }}>


            {(floodOptions.length ? floodOptions : ["All", "High", "Moderate", "Low", "Unknown"]).map((r) => (
              <div key={r} onClick={() => { setFloodRiskFilter(r); setOpen((s) => ({ ...s, flood: false })); }} style={{ padding: 8, cursor: "pointer", background: floodRiskFilter === r ? "#1c8f7d" : "transparent", color: floodRiskFilter === r ? "#fff" : "#000" }}>{r}</div>
            ))}
          </div>
        )}
      </div> */}


      {/* Listed Sales */}
      {/* <div>
        <Button color="primary filter-button" variant="text" endIcon={<ArrowDropDownIcon />} onClick={() => setOpen((s) => ({ ...s, listed: !s.listed }))} sx={{ textTransform: "none", color: open.listed ? "#fff" : "#333", backgroundColor: open.listed ? "#1c8f7d" : "transparent", borderRadius: "6px" }}>
          Listed Sales
        </Button>
        {open.listed && (
          <div style={{ position: "absolute", top: 130, left: 460, zIndex: 999, background: "#fff", padding: 6, borderRadius: 6, boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}>
            {["All", "Listed", "Unlisted"].map((v) => (
              <div key={v} onClick={() => { setListedSalesFilter(v); setOpen((s) => ({ ...s, listed: false })); }} style={{ padding: 8, cursor: "pointer", background: listedSalesFilter === v ? "#1c8f7d" : "transparent", color: listedSalesFilter === v ? "#fff" : "#000" }}>{v}</div>
            ))}
          </div>
        )}
      </div> */}

      {/* Listed Sales (options derived from data) */}
      <div>
        <Button color="primary filter-button" variant="text" endIcon={<ArrowDropDownIcon />}
          //  onClick={() => setOpen((s) => ({ ...s, listed: !s.listed }))} 
          onClick={() => setOpen({ price: false, area: false, app: false, flood: false, zone: false, zestimate: false, spread: false, listed: true })}
          sx={{ textTransform: "none", color: open.listed ? activeColor : (isListedActive ? activeColor : inactiveColor), backgroundColor: open.listed ? activeBg : (isListedActive ? activeBg : inactiveBg), borderRadius: "6px" }}>
          {/* <Button
          color="primary filter-button"
          variant="text"
          endIcon={<ArrowDropDownIcon />}
          onClick={() => setOpen((s) => ({ ...s, listed: !s.listed }))}
          sx={{
            textTransform: "none",
            color: open.listed ? activeColor : (isListedActive ? activeColor : inactiveColor),
            backgroundColor: open.listed ? activeBg : (isListedActive ? activeBg : inactiveBg),
            borderRadius: "6px",
          }}
        > */}
          Listing Status
        </Button>
        {open.listed && (
          <div style={{ position: "absolute", top: 163, left: 840, zIndex: 999, background: "#fff", padding: 6, borderRadius: 6, boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}>
            {(listedOptions || ["All"]).map((v) => (
              <div key={v} onClick={() => { setListedSalesFilter(v); setOpen((s) => ({ ...s, listed: false })); }} style={{ padding: 8, cursor: "pointer", background: listedSalesFilter === v ? "#1c8f7d" : "transparent", color: listedSalesFilter === v ? "#fff" : "#000" }}>{v}</div>
            ))}
          </div>
        )}
      </div>


      {/* Clear Filters */}
      <div style={{ marginLeft: "auto" }}>
        <Button
          color="primary filter-button"
          variant="outlined"
          style={{ textTransform: "none", borderColor: "#cfcfcf", color: "#333", marginLeft: 8 }}
          onClick={() => {
            // reset all filters to defaults
            setPriceRange([sliderMinMax.minPrice ?? 0, sliderMinMax.maxPrice ?? 1000000]);
            setAreaRange([sliderMinMax.minArea ?? 0, sliderMinMax.maxArea ?? 5000]);
            setZestimateRange([sliderMinMax.minZestimate ?? 0, sliderMinMax.maxZestimate ?? 1000000]);
            setSpreadRange([sliderMinMax.minSpread ?? 0, sliderMinMax.maxSpread ?? 100]);
            setAppreciationValue("All");
            setFloodRiskFilter("All");
            setZoneCodeFilter("All");
            setListedSalesFilter("All");
            setOpen({ price: false, area: false, app: false, flood: false, zone: false, zestimate: false, spread: false, listed: false });
          }} sx={{ textTransform: "none", borderColor: "#ccc" }}>
          Clear Filters
        </Button>
      </div>

    </div>
  );
}